import styled from 'styled-components';

export const SiteFooter = styled.footer`
  position: relative;
  /* top: 90%; */

  background-color: var(--nightBlue);
  color: var(--thunderCloudGrey);
  font-size: var(--small);

  padding: 1.5rem 1rem 0.5rem 1rem;

  img {
    height: 1.5rem;
  }

  @media screen and (min-width: 480px) {
    display: flex;
    justify-content: space-between;

    p {
      flex-basis: 2;
      max-width: 70%;
    }
  }
`;
